import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function ImageUpload({ value, onChange, testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd);
      onChange(data.url);
      toast.success("Photo uploaded 📸");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Upload failed");
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div data-testid={testid}>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handle} data-testid={`${testid}-input`} />
      {value ? (
        <div className="relative rounded-2xl overflow-hidden border border-slate-200">
          <img src={value} alt="preview" className="w-full h-40 object-cover" />
          <button type="button" onClick={() => onChange("")} data-testid={`${testid}-remove`}
            className="absolute top-2 right-2 bg-black/60 text-white rounded-full p-1.5 hover:bg-black/80">
            <X className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <button type="button" onClick={() => inputRef.current?.click()} data-testid={`${testid}-btn`} disabled={loading}
          className="w-full rounded-2xl border-2 border-dashed border-slate-300 py-6 flex flex-col items-center gap-2 text-slate-500 hover:border-[#FF5A79] hover:text-[#FF5A79] transition">
          {loading ? <Loader2 className="h-6 w-6 animate-spin" /> : <ImagePlus className="h-6 w-6" />}
          <span className="text-sm font-semibold">{loading ? "Uploading…" : "Upload a photo"}</span>
        </button>
      )}
    </div>
  );
}
